// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"bE-z","smallCardRow":"cE-z","largeCardRow":"dE-z","productSearchRow":"eE-z","curatedRow":"fE-z"};